import classes from "./Menu.module.css";
import Icon from "./icon/Icon";
import {IconDotsVertical, IconEdit, IconFolder, IconPalette} from "@tabler/icons-react";
import {useContext} from "react";
import QRCodeStyleDialogContext from "../../../../../../../dialogs/qr-code/style/QRCodeStyleDialogContext";
import QRCodeViewItemContext from "../../../QRCodeViewItemContext";
import QRCodeFolderDialogContext from "../../../../../../../dialogs/qr-code/folder/QRCodeFolderDialogContext";
import MenuIcon from "./icon/MenuIcon";
import {MenuItem} from "@mantine/core";
import Notifications from "../../../../../../../../utils/notifications/Notifications";
import {useNavigate} from "react-router-dom";
import QRCodeApi from "../../../../../../../../api/qr-code/QRCodeApi";
import {saveAs} from "file-saver";

/**
 * Menu to be displayed under the download button
 * @author Kacper Faber
 * @since 0.1.9
*/
function Menu() {
    const ctx = useContext(QRCodeViewItemContext);

    /**
     * Navigate function
     * @author Kacper Faber
     * @since 0.2.0
     */
    const navigate = useNavigate();

    /**
     * QRCodeFolderDialogContext
     * @since 0.1.9
     * @author Kacper Faber
     */
    const folderDialog = useContext(QRCodeFolderDialogContext);

    /**
     * QRCodeStyleDialogContext
     * @author Kacper Faber
     * @since 0.1.9
    */
    const styleDialog = useContext(QRCodeStyleDialogContext);

    // /**
    //  * Throws not implemented error.
    //  * @author Kacper Faber
    //  * @since 0.1.9
    // */
    // const notImplemented = () => {
    //     throw new Error('This button is not implemented.');
    // }

    const onStyleClick = () => {
        if (!ctx.qrCode) {
            throw new Error('Cannot open the style dialog, because QRCode in context is undefined');
        }

        styleDialog.open(ctx.qrCode);
    }

    const onFolderClick = () => {
        if (!ctx.qrCode) {
            throw new Error('Cannot open the folder dialog, because QRCode in context is undefined');
        }

        folderDialog.open(ctx.qrCode);
    }

    /**
     * Delete QRCode.
     * @author Kacper Faber
     * @since 0.1.9
     */
    const onDeleteClicked = () => {
        ctx.delete()
            .then(Notifications.onDeleteSuccess)
            .catch(Notifications.onDeleteFailed);
    }

    const onEditClicked = () => {
        navigate(`/qr-code/edit/${ctx.qrCode?.id}`);
    }

    const downloadPdf = () => {
        QRCodeApi.downloadPdf(ctx.qrCode?.id ?? 0)
            .then(async (r) => saveAs(await r.blob()))
            .catch(Notifications.onFetchError);
    }

    const downloadSvg = () => {
        QRCodeApi.downloadSvg(ctx.qrCode?.id ?? 0)
            .then(async (r) => saveAs(await r.blob()))
            .catch(Notifications.onFetchError);
    }

    return (
        <div className={classes.root}>
            <Icon
                onClick={onEditClicked}
                children={<IconEdit/>}
            />

            <Icon
                onClick={onStyleClick}
                children={<IconPalette/>}
            />

            <Icon
                onClick={onFolderClick}
                children={<IconFolder/>}
            />

            <MenuIcon icon={<IconDotsVertical/>}>
                <MenuItem onClick={downloadPdf}>
                    Pobierz PDF
                </MenuItem>

                <MenuItem onClick={downloadSvg}>
                    Pobierz SVG
                </MenuItem>

                <MenuItem onClick={onDeleteClicked}>
                    Usuń
                </MenuItem>
            </MenuIcon>
        </div>
    );
}

export default Menu;